var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabWeightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.521,
    height: 17.268,
    viewBox: "0 0 18.521 17.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12527",
    "data-name": "Group 12527",
    transform: "translate(1184.675 -428.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12521",
    "data-name": "Group 12521",
    transform: "translate(-2478 -417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39707",
    "data-name": "Path 39707",
    d: "M1298.748,850.7h-1.467a.609.609,0,0,0-.587.444l-3.014,10.666a.609.609,0,0,0,.586.776H1310.9a.61.61,0,0,0,.587-.776l-3.015-10.666a.609.609,0,0,0-.587-.444h-1.747",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39708",
    "data-name": "Path 39708",
    d: "M1306.142,847.1a1.126,1.126,0,0,0-1.123-1.123h-5.148a1.126,1.126,0,0,0-1.123,1.123v3.6h7.394Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39709",
    "data-name": "Path 39709",
    d: "M1298.709,858.885v-4.274h.566v2.119l2.122-2.119h.767l-1.793,1.732,1.872,2.542h-.747l-1.522-2.163-.7.682v1.481Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39710",
    "data-name": "Path 39710",
    d: "M1304.715,857.209v-.5l1.811,0v1.586a3.214,3.214,0,0,1-.861.5,2.563,2.563,0,0,1-.909.167,2.43,2.43,0,0,1-1.145-.269,1.786,1.786,0,0,1-.777-.78,2.455,2.455,0,0,1-.262-1.14,2.648,2.648,0,0,1,.261-1.165,1.736,1.736,0,0,1,.751-.8,2.348,2.348,0,0,1,1.128-.263,2.238,2.238,0,0,1,.838.15,1.4,1.4,0,0,1,.588.419,1.856,1.856,0,0,1,.323.7l-.51.14a1.592,1.592,0,0,0-.239-.514.974.974,0,0,0-.408-.3,1.493,1.493,0,0,0-.589-.113,1.75,1.75,0,0,0-.671.118,1.265,1.265,0,0,0-.456.311,1.462,1.462,0,0,0-.27.423,2.25,2.25,0,0,0-.163.86,2.085,2.085,0,0,0,.2.956,1.259,1.259,0,0,0,.573.572,1.78,1.78,0,0,0,.8.186,1.9,1.9,0,0,0,.717-.141,1.858,1.858,0,0,0,.531-.3v-.8Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabWeightIcon);
export default __webpack_public_path__ + "static/media/tab-weight-icon.bca72e7d07505e64d0d63b588c6ff700.svg";
export { ForwardRef as ReactComponent };